import React from 'react';
import { useAppUser } from 'App/components/utils/providers/AppUserProvider';
import { useAppLogger } from 'Services/logger';
import { createRemindersApi } from './taskSdk';

const initialFetchDelayMs = 1000;
const refreshIntervalMs = 60000;

export const useReminderCount = (): number => {
  const user = useAppUser();
  const logger = useAppLogger();
  const [ amount, setAmount ] = React.useState<number>( 0 );

  const remindersApi = React.useMemo( () => createRemindersApi(), [] );

  React.useEffect( () => {
    let intervalId: number | undefined;
    let timeoutId: number | undefined;
    let isMounted = true;

    const fetchCount = async (): Promise<void> => {
      if ( !user?.sub || !user.token.current?.value ) {
        return;
      }

      try {
        const response = await remindersApi.getReminderCounts( {
          authorization: `Bearer ${user.token.current.value}`,
          filters: `userSub==${user.sub}`,
        } );

        if ( isMounted ) {
          const data = response.data;
          setAmount( ( data.dueCount ?? 0 ) + ( data.overdueCount ?? 0 ) );
        }
      } catch ( error ) {
        logger.error( error );
      }
    };

    timeoutId = window.setTimeout( fetchCount, initialFetchDelayMs );
    intervalId = window.setInterval( fetchCount, refreshIntervalMs );

    return () => {
      isMounted = false;
      window.clearTimeout( timeoutId );
      window.clearInterval( intervalId );
    };
  }, [ logger, remindersApi, user ] );

  return amount;
};
